/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_1655f572"]'><cube-button inline primary>inline - primary</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_1655f572"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_1655f572"}
  /** script content **/
  require("./btn-inline-primary.mpx.js?isComponent&outputPath=components%2Fbtn-inline-primary1655f572%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-inline-primary.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-inline-primary1655f572%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_1655f572"],
    ctorType: "component",
    outputPath: "components/btn-inline-primary1655f572/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>